import { OpenThermStatusFlag } from 'openTherm';
import { createSubsetSelector } from 'webui/utils/selectors';
import { mergeThermometer } from '../utils';
import { partial } from 'webui/utils/functions';
import { formatTemp } from 'utils';
export const legacy_heating_circuits_config = createSubsetSelector([
    'id',
    'thermostat_zones_settings',
    'thermostat_target_temps',
    'pza',
    'ot_enabled',
    'thermometers',
    'ot_config',
]);
export const legacy_heating_circuits_state = createSubsetSelector([
    'id',
    'last_boiler_state',
    'otzones_last',
    'ot_zones_count',
    'thermostat_temps_limits',
    'thermostat_target_temps',
    'thermostat_ext_mode',
    'thermostat_ext_modes_config',
    'thermometers',
    'tempschedule',
    'timezone',
]);
export const legacy_boiler_heating_circuits_config = createSubsetSelector([
    'id',
    'ot_boiler_type',
    'ot_enabled',
    'ot_save_params',
    'thermostat_zones_settings',
    'ot_zones_count',
]);
export const legacy_boiler_heating_circuits_state = createSubsetSelector([
    'id',
    'last_boiler_state',
    'thermostat_target_temps',
    'otzones_last',
    'thermometers',
]);
export function getLegacyHeatingCircuitName(zone_id, zone_count, zone_settings) {
    if (~~zone_id === 0) {
        return 'Горячая вода';
    }
    if (zone_count === 2) {
        return 'Отопление';
    }
    if (zone_settings?.name != null) {
        return zone_settings.name;
    }
    return `Отопление №${zone_id}`;
}
export function getLegacyDhwAdapterCurrentTemperature(otzones, ot_zones_count, last_boiler_state) {
    if (otzones != null) {
        const dhw_temperatures = new Array(ot_zones_count)
            .fill(0)
            .map((_, i) => otzones[i]?.dt)
            .filter((x) => x != null);
        if (dhw_temperatures && dhw_temperatures.length > 0) {
            return Math.max(...dhw_temperatures);
        }
        return null;
    }
    else {
        return last_boiler_state?.ot?.dt;
    }
}
export function getLegacyRelayBoilerCurrentTemperature(default_thermometers) {
    return default_thermometers.water.main.temperature ?? undefined;
}
export function getLegacyDhwRelayCurrentTemperature(default_thermometers, is_water) {
    if (is_water) {
        return default_thermometers.water.main.temperature;
    }
    return null;
}
export function isLegacyDhwWorking(otzones, ot_zones_count, last_boiler_state) {
    const zones_count = ot_zones_count || 0;
    if (otzones != null) {
        for (let i = 0; i < zones_count; i++)
            if ((otzones[i]?.s ?? []).includes(OpenThermStatusFlag.dhw)) {
                return true;
            }
        return false;
    }
    else {
        return (last_boiler_state?.ot?.s ?? []).includes(OpenThermStatusFlag.dhw);
    }
}
//thermometers
export function isThermometerAssignedToSlot(slot, thermometers) {
    for (const therm of thermometers)
        if (therm.is_assigned_to_slot && therm.slot === slot) {
            return therm;
        }
    return null;
}
function findLegacyThermometer(zone_id, predicate, thermometer) {
    if (!thermometer.is_assigned_to_slot) {
        return false;
    }
    return thermometer.functions.find((thermometer_function) => {
        const thermometer_predicate = predicate === null ? true : predicate(thermometer_function.f);
        return thermometer_predicate && thermometer_function.zone === zone_id;
    });
}
function getHeatingCircuitThermometerConfig(id, thermometer) {
    if (thermometer) {
        const { name } = thermometer;
        return {
            id,
            name,
        };
    }
    return {
        id: null,
        name: null,
    };
}
function getHeatingCircuitThermometerState(thermometer) {
    if (thermometer) {
        const { last_value, last_state } = thermometer;
        return {
            temperature: last_value ?? null,
            format_temp: formatTemp(last_value),
            work_fine: last_state == 'ok',
        };
    }
    return {
        temperature: null,
        format_temp: null,
        work_fine: null,
    };
}
function getHeatingCircuitThermometer(id, thermometer) {
    return {
        ...getHeatingCircuitThermometerConfig(id, thermometer),
        ...getHeatingCircuitThermometerState(thermometer),
    };
}
export function getLegacyDefaultTargetThermometer(zone_id, mode_id, props) {
    const { thermostat_ext_mode = 0, thermostat_ext_modes_config, thermometers, tempschedule, timezone, } = props;
    if (!thermometers) {
        return [undefined, null];
    }
    const week = tempschedule?.week;
    if (zone_id === 0) {
        return [undefined, null];
    }
    if (mode_id == null) {
        mode_id = thermostat_ext_mode;
    }
    const mode = thermostat_ext_modes_config?.[mode_id];
    if (mode?.schedule_number != null && week != null) {
        const day_no = 2 <= mode.schedule_number && mode.schedule_number <= 8
            ? mode.schedule_number - 2
            : (new Date().getDay() + 6) % 7;
        const hour = (new Date().getUTCHours() + timezone) % 24;
        const cell = week[day_no]?.[hour].toString();
        if (cell?.startsWith?.('M')) {
            const schedule_mode_id = parseInt(cell[1], 10);
            if (schedule_mode_id &&
                !isNaN(schedule_mode_id) &&
                schedule_mode_id !== mode_id)
                return getLegacyDefaultTargetThermometer(zone_id, schedule_mode_id, props);
        }
    }
    const zone_sensor_slot = mode?.zone_sensors?.[zone_id];
    if (zone_sensor_slot != null) {
        const target_thermometer = isThermometerAssignedToSlot(zone_sensor_slot, thermometers);
        if (target_thermometer != null) {
            return [
                target_thermometer,
                getHeatingCircuitThermometer(zone_id, target_thermometer),
            ];
        }
    }
    const target_thermometer = thermometers.find(partial(findLegacyThermometer, zone_id, (thermometer_function) => thermometer_function === 'control'));
    if (target_thermometer == null) {
        return [undefined, null];
    }
    return [
        target_thermometer,
        getHeatingCircuitThermometer(zone_id, target_thermometer),
    ];
}
export function getThermometerConfig(zone_id, thermometers, predicate) {
    if (!thermometers || zone_id === 0) {
        return {
            id: null,
            name: null,
        };
    }
    const thermometer = thermometers.find(partial(findLegacyThermometer, zone_id, predicate));
    if (thermometer) {
        return {
            id: zone_id,
            name: thermometer.name,
        };
    }
    return {
        id: null,
        name: null,
    };
}
function getLegacyHeatingCircuitThermometersPairConfig(zone_id, thermometers, main_condition, reserve_condition) {
    return {
        main: getThermometerConfig(zone_id, thermometers, (func) => func == main_condition),
        reserve: getThermometerConfig(zone_id, thermometers, (func) => func == reserve_condition),
    };
}
export function getLegacyHeatingCircuitThermometerState(config, thermometers) {
    const { id } = config;
    const thermometer = id
        ? thermometers.find(partial(findLegacyThermometer, id, null))
        : null;
    return getHeatingCircuitThermometerState(thermometer);
}
export function getLegacyHeatingCircuitThermometersPairState(thermometers_pair_config, thermometers) {
    return {
        main: getLegacyHeatingCircuitThermometerState(thermometers_pair_config.main, thermometers),
        reserve: getLegacyHeatingCircuitThermometerState(thermometers_pair_config.reserve, thermometers),
    };
}
export function getThermometerState(config, thermometers) {
    const { id } = config;
    const thermometer = id
        ? thermometers.find(partial(findLegacyThermometer, id, null))
        : null;
    return getHeatingCircuitThermometerState(thermometer);
}
export function getLegacyHeatingCircuitThermometersConfig(zone_id, thermometers) {
    return {
        air: getLegacyHeatingCircuitThermometersPairConfig(zone_id, thermometers, 'control', 'control-reserve'),
        water: getLegacyHeatingCircuitThermometersPairConfig(zone_id, thermometers, 'heat'),
    };
}
export function getLegacyTargetThermometer(thermometer, thermometers, control_mode) {
    if (thermometer != null && thermometer.id != null) {
        return thermometer;
    }
    const { is_water, is_air } = control_mode;
    const { air, water } = thermometers;
    if (is_water) {
        return water.main;
    }
    if (is_air) {
        return air.main.name ? air.main : air.reserve;
    }
    return {
        id: null,
        name: null,
        format_temp: null,
        temperature: null,
        work_fine: null,
    };
}
export function getLegacyHeatingCircuitThermometers(thermometers_config, thermometers = []) {
    const { air, water } = thermometers_config;
    const air_state = getLegacyHeatingCircuitThermometersPairState(air, thermometers);
    const water_state = getLegacyHeatingCircuitThermometersPairState(water, thermometers);
    return {
        air: mergeThermometer(air, air_state),
        water: mergeThermometer(water, water_state),
    };
}
export function getLegacyControlConfig(sensors) {
    const is_cooling = false;
    const is_air_pid = false;
    const is_water = sensors.water.main.name != null;
    const is_air = (sensors.air.main.name != null || sensors.air.reserve.name != null) &&
        !is_water;
    return { is_cooling, is_air_pid, is_water, is_air };
}
